// The consult reason in Swedish, in one place.
//
// TES-812 — this table existed THREE times, character-identical, in
// PatientMeetings, MeetingHeader and Today. Needing it a fourth time (the
// Webdoc-confirmation card, which now names the consult it is about) is the
// point at which copying it again stops being cheaper than moving it.
//
// Same reasoning as `lib/error-text.ts`, which moved out of MeetingRoom when a
// second caller appeared: a label table is shared vocabulary, and three copies
// of a vocabulary are three chances for one surface to call the same consult
// something the next one doesn't.
//
// Free string on the wire (Meeting.reason is a plain column), so an unknown
// value falls back to itself rather than rendering blank — a reason we have no
// Swedish for is still better shown raw than hidden.
export const MEETING_REASON_LABEL: Record<string, string> = {
  first_consult: "Första besök",
  renewal_review: "Receptförnyelse",
  follow_up: "Uppföljning",
};

export function meetingReasonLabel(reason: string | null | undefined): string {
  if (!reason) return "—";
  return MEETING_REASON_LABEL[reason] ?? reason;
}

// TES-1183 (TES-1180 point 8) — the line over "Att dokumentera". A-02
// 2026-10-08 keeps the automation that closes onboarding's meeting step when
// the time has passed, and: "Ett passerat mötessteg får dock aldrig ensamt
// publicera behandlingsbeslut, skapa receptstatus eller visa
// uthämtningsinformation." Proposed copy, awaiting Emelie.
export const PASSED_MEETING_NOTE =
  "Mötet avslutas automatiskt när tiden har passerat. Dokumentationen och behandlingsbeslutet gör du – ett passerat möte beslutar ingenting.";
